import { useGuidedTour } from 'hooks/useGuidedTour';
import { type ComponentType, useCallback, useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

import { SurveyContainer } from './surveyContainer';

interface ButtonProps {
  toggle: () => void;
}

function DefaultButton({ toggle }: ButtonProps) {
  const { formatMessage } = useIntl();
  return (
    <button
      className="btn btn-lg btn-flat-primary btn-icon-end"
      data-e2e="app-feedback-button"
      role="button"
      onClick={toggle}
      data-tour="menu.appFeedback"
    >
      <span className="d-none d-xxl-inline text-nowrap">
        <FormattedMessage id="appFeedback.iconTitle" />
      </span>
      <i className="icon" title={formatMessage({ id: 'appFeedback.title' })}>
        try
      </i>
    </button>
  );
}

export interface AppFeedbackProps {
  Button?: ComponentType<ButtonProps>;
  withGuidedTour?: boolean;
}

export function AppFeedback({ Button = DefaultButton, withGuidedTour = true }: AppFeedbackProps) {
  useGuidedTour(withGuidedTour);

  const [isOpened, setIsOpened] = useState(false);
  const toggle = useCallback(() => setIsOpened(opened => !opened), []);

  return (
    <>
      <Button toggle={toggle} />
      <Modal show={isOpened} onHide={toggle} size="xl">
        <ModalHeader onToggle={toggle} closeButton>
          <ModalTitle as="h2">
            <FormattedMessage id="appFeedback.title" />
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <SurveyContainer />
        </ModalBody>
      </Modal>
    </>
  );
}
